import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ProcessManager from './component'
import { selectors as imported } from '../../../../imports'
import { setClientProcessRunningState, getProcessManagerErrorText } from '../../../../data'

function mapStateToProps(state) {
    return {
        error: {
            title: imported.getAttentionText(state),
            message: getProcessManagerErrorText(state),
        },
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ setClientProcessRunningState }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcessManager)



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/ProcessManager/index.js